module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter.var.woff2?f065685b633569a6ec753c157b22a382";